export const EDITOR_TOOLBAR =
  "formatselect | code image | bold italic underline backcolor | bullist numlist | outdent indent | \
alignleft aligncenter alignright alignjustify | \
undo redo | removeformat | help";

export const TABLE_TOOLBAR =
  "tableprops tabledelete tablemergecells tablesplitcells | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol";
